import React from 'react'
import ChangePassword from '../components/auth/changePassword/ChangePassword'

const ChangePasswordPage = () => {
    return (
        <div className='outletConainer'>
            <ChangePassword />
        </div>
    )
}

export default ChangePasswordPage